import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { Stepper as Stepper$1 } from 'primereact/stepper';
import { StepperPanel as StepperPanel$1 } from 'primereact/stepperpanel';
import './Stepper.scss.js';

const StepperPanel = StepperPanel$1;
function Stepper(_a) {
  var {
      variant = 'default',
      className
    } = _a,
    props = __rest(_a, ["variant", "className"]);
  const variantClass = variant === 'pill' ? 'ics-stepper-pill' : '';
  const combinedClassName = [variantClass, className].filter(Boolean).join(' ');
  return jsx(Stepper$1, Object.assign({
    className: combinedClassName
  }, props));
}

export { Stepper, StepperPanel };
